import {createAsyncThunk, createSlice, isFulfilled, isPending, isRejected} from '@reduxjs/toolkit';
import {RootState} from '../../../../Config/Store';
import axios from 'axios';
import {serializeAxiosError} from "../../../../Config/Reducers/ReducerUtils";
import {ChartState} from "../../../../Config/Types";
import {LocalDateTimeFormatISO} from "../../../../Utils/DateFormatPatternUtils";

export class GenerationEntity {
    expectedPerformanceRatio: number;
    dateTime: string;
    powerStationName:string;
    performanceRatioValue: number;
    availability: number;

    constructor(expectedPerformanceRatio: number, dateTime: string,  powerStationName:string, performanceRatioValue: number,availability:number) {
        this.expectedPerformanceRatio = expectedPerformanceRatio;
        this.dateTime = dateTime;
        this.powerStationName = powerStationName;
        this.performanceRatioValue = performanceRatioValue;
        this.availability = availability;
    }
}

const initialState: ChartState = {
    loading: false,
    errorMessage: null,
    entities: new Array<GenerationEntity>(),
    entity: undefined,
    updating: false,
    updateSuccess: false,
};

const apiUrl = 'api/generation-energy/performance-ratio';

// TODO change the any type to the proper payload type
export const getEntities = createAsyncThunk<any, any>(
    'generation performace-ratio/fetch_entity_list',
    async ({period, powerPlant}) => {
        let groupBy:string = 'day';
        if( period.groupBy.includes('week') ||  period.groupBy.includes('month')){
            groupBy = 'day';
        } else if( period.groupBy.includes('year')) {
            groupBy = 'month';
        } else if( period.groupBy.includes('general')){
            groupBy = 'year';
        }
        return axios.get<GenerationEntity>(`${apiUrl}/${powerPlant}/${groupBy}?startDateTime=${LocalDateTimeFormatISO(period.fromDateTime ? period.fromDateTime : new Date())}&endDateTime=${LocalDateTimeFormatISO(period.toDateTime ? period.toDateTime : new Date())}`);
    },
    { serializeError: serializeAxiosError }
);

export const getEntity = createAsyncThunk<any, any, {rejectValue: any }>(
    'generation-performace-ratio/fetch_entity',
    async () => {
        return axios.get<GenerationEntity>(`${apiUrl}`);
    },
    { serializeError: serializeAxiosError }
);

// Slices
const generationPRChartReducer = createSlice({
    name: 'generationPRChartReducer',
    initialState,
    reducers: {
        /**
         * Reset the entity state to initial state
         */
        reset() {
            return initialState;
        },
        clear: (state) => {
            state.entity = { expectedPerformanceRatio: 0, dateTime:"",powerStationName:"", performanceRatioValue:0};
        },
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder
            .addCase(getEntity.fulfilled, (state, action) => {
                state.loading = false;
                state.entity = action.payload.data.data;
            })
            .addMatcher(isFulfilled(getEntities, getEntity), (state, action) => {
                return {
                    ...state,
                    loading: false,
                    entities: action.payload.data.data,
                }
            })
            .addMatcher(isPending(getEntities, getEntity), state => {
                state.errorMessage = null;
                state.updateSuccess = false;
                state.loading = true;
                state.entities = [];
            })
            .addMatcher(isRejected(getEntities, getEntity), state => {
                state.loading = false;
                state.errorMessage = "Error ao carregar dados de Performance Ratio"
            })
    },
})

export const { reset } = generationPRChartReducer.actions;
export const selectGenerationPRChart = (state: RootState) => state.generationPRChartPlant;

// Reducer
export default generationPRChartReducer.reducer;